export const environment = {
  production: false,
  backendHost: '/admin',
  proxy: false
};
